import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import {
  DataEntityLayoutModel,
  ActivityModel,
  Activity
} from '../../../../models/activities';
import { UntypedFormGroup } from '@angular/forms';
import { DataEntityInputComponent } from '../data-entity-input/data-entity-input.component';
import { Subscription } from 'rxjs';
import { DataEntityRowLayoutInputComponent } from '../data-entity-row-layout/data-entity-row-layout-input/data-entity-row-layout-input.component';
import { DataEntityTableLayoutInputComponent } from '../data-entity-table-layout/data-entity-table-layout-input/data-entity-table-layout-input.component';
import { DataEntityGroupLayoutInputComponent } from '../data-entity-group-layout/data-entity-group-layout-input/data-entity-group-layout-input.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-data-entity-input-list',
    templateUrl: './data-entity-input-list.component.html',
    styleUrls: ['./data-entity-input-list.component.css'],
    standalone: false
})
export class DataEntityInputListComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() entities: DataEntityLayoutModel[];
  @Input() form: UntypedFormGroup;
  @Input() activity: Activity<ActivityModel>;
  @Input() applicationId: string;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  @Output() calculateActivity: EventEmitter<{
    templateCode: string;
    calculateFormula?: boolean;
    visReq?: boolean;
  }> = new EventEmitter();
  calculateSubscriptions: Subscription[] = [];

  @ViewChildren('dataEntityInput')
  dataEntityInputCtls: QueryList<DataEntityInputComponent>;
  @ViewChildren('dataEntityGroupLayoutInput')
  dataEntityGroupLayoutInputCtls: QueryList<DataEntityGroupLayoutInputComponent>;
  @ViewChildren('dataEntityTableLayoutInput')
  dataEntityTableLayoutInputCtls: QueryList<DataEntityTableLayoutInputComponent>;
  @ViewChildren('dataEntityRowLayoutInput')
  dataEntityRowLayoutInputCtls: QueryList<DataEntityRowLayoutInputComponent>;
  templateForPermitForm: boolean;

  constructor(public layoutService: LayoutService, context : WorkflowContextService) {
     //added by priya 05-01-2026
     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
     //end by priya 05-01-2026
  }
  ngOnDestroy(): void {
    this.calculateSubscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
  ngAfterViewInit(): void {
    if (this.dataEntityInputCtls) {
      this.dataEntityInputCtls.forEach(dataEntityInputCrl => {
        const subscription = dataEntityInputCrl.calculateActivity.subscribe(
          e => {
            this.calculateActivity.emit(e);
          }
        );
        this.calculateSubscriptions.push(subscription);
      });
    }

    if (this.dataEntityGroupLayoutInputCtls) {
      this.dataEntityGroupLayoutInputCtls.forEach(groupLayoutCtl => {
        const subscription = groupLayoutCtl.calculateActivity.subscribe(
          e => {
            this.calculateActivity.emit(e);
          }
        );
        this.calculateSubscriptions.push(subscription);
      });
    }

    if (this.dataEntityTableLayoutInputCtls) {
      this.dataEntityTableLayoutInputCtls.forEach(tableLayoutCtl => {
        const subscription = tableLayoutCtl.calculateActivity.subscribe(
          e => {
            this.calculateActivity.emit(e);
          }
        );
        this.calculateSubscriptions.push(subscription);
      });
    }

    if (this.dataEntityRowLayoutInputCtls) {
      this.dataEntityRowLayoutInputCtls.forEach(rowLayoutCtl => {
        const subscription = rowLayoutCtl.calculateActivity.subscribe(
          e => {
            this.calculateActivity.emit(e);
          }
        );
        this.calculateSubscriptions.push(subscription);
      });
    }
  }

  async persistChildComponent() {
    const p: Promise<any>[] = [];
    this.dataEntityInputCtls.forEach(dataEntityInputCrl => {
      p.push(dataEntityInputCrl.persistChildComponent());
    });
    this.dataEntityGroupLayoutInputCtls.forEach(dataEntityGroupLayoutInputCrl => {
      p.push(dataEntityGroupLayoutInputCrl.persistChildComponent());
    });
    this.dataEntityTableLayoutInputCtls.forEach(dataEntityTableLayoutInputCrl => {
      p.push(dataEntityTableLayoutInputCrl.persistChildComponent());
    });
    this.dataEntityRowLayoutInputCtls.forEach(dataEntityRowLayoutInputCrl => {
      p.push(dataEntityRowLayoutInputCrl.persistChildComponent());
    });
    return Promise.all(p);
  }

  cancelCalculation(templateCode: string) {
    this.dataEntityInputCtls.forEach(ctl => {
      if (ctl.entity.templateCode == templateCode) {
        ctl.cancelCalculation();
      }
    });

    this.dataEntityGroupLayoutInputCtls.forEach(ctl => {
      ctl.cancelCalculation(templateCode);
    });

    this.dataEntityTableLayoutInputCtls.forEach(ctl => {
      // Table layout doesn't have entities with templateCode directly
      // It needs to propagate to its children
      if (ctl.dataEntityInputCtls) {
        ctl.dataEntityInputCtls.forEach(entityCtl => {
          if (entityCtl.entity?.templateCode === templateCode) {
            entityCtl.cancelCalculation();
          }
        });
      }
    });

    this.dataEntityRowLayoutInputCtls.forEach(ctl => {
      ctl.cancelCalculation(templateCode);
    });
  }

  ngOnInit() {}
}
